export const isTcoatQuotationItem = (item = {}, paintSkuSet = null, upsellingSkuSet = null) => {
  const sku = String(item.product_sku || item.item_code || '').trim();
  const skuKey = sku.toUpperCase();
  if (skuKey && upsellingSkuSet && upsellingSkuSet.has(skuKey)) return false;
  if (skuKey && paintSkuSet && paintSkuSet.has(skuKey)) return true;
  const name = String(item.item_name || item.product_name || '');
  if (paintSkuSet || upsellingSkuSet) return false;
  return /t-?coat/i.test(name);
};

export const isUpsellingQuotationItem = (item = {}, paintSkuSet = null, upsellingSkuSet = null) => {
  const sku = String(item.product_sku || item.item_code || '').trim();
  const skuKey = sku.toUpperCase();
  if (skuKey && upsellingSkuSet && upsellingSkuSet.has(skuKey)) return true;
  if (skuKey && paintSkuSet && paintSkuSet.has(skuKey)) return false;
  if (paintSkuSet || upsellingSkuSet) return false;
  return !isTcoatQuotationItem(item, paintSkuSet, upsellingSkuSet);
};

export const partitionQuotationLineItems = (lineItems = [], paintSkuSet = null, upsellingSkuSet = null) => {
  const production = [];
  const upselling = [];
  (lineItems || []).forEach((item) => {
    if (isTcoatQuotationItem(item, paintSkuSet, upsellingSkuSet)) {
      production.push(item);
    } else if (isUpsellingQuotationItem(item, paintSkuSet, upsellingSkuSet)) {
      upselling.push(item);
    }
  });
  return { production, upselling };
};

export const buildDefaultLineSelections = (items = []) => {
  const map = {};
  (items || []).forEach((item) => {
    const id = Number(item.id);
    if (!id) return;
    map[id] = {
      enabled: true,
      quantity: String(item.quantity ?? ''),
    };
  });
  return map;
};

/** Same shape as defaults, but with every line unchecked (omit request). */
export const buildClearedLineSelections = (items = []) => {
  const map = {};
  (items || []).forEach((item) => {
    const id = Number(item.id);
    if (!id) return;
    map[id] = {
      enabled: false,
      quantity: String(item.quantity ?? ''),
    };
  });
  return map;
};

export const updateLineSelectionMap = (prev, itemId, field, value) => {
  const id = Number(itemId);
  const current = prev?.[id] || { enabled: false, quantity: '' };
  const nextRow = { ...current, [field]: value };
  if (field === 'enabled' && value && (nextRow.quantity === '' || nextRow.quantity == null)) {
    nextRow.quantity = '';
  }
  return { ...(prev || {}), [id]: nextRow };
};

/** Returns error message or '' if ok. */
export const validateLineSelections = (items = [], selectionMap = {}, label = 'ítems') => {
  const list = Array.isArray(items) ? items : [];
  if (!list.length) return `No hay ${label} en la venta seleccionada.`;
  const enabled = list.filter((item) => selectionMap?.[Number(item.id)]?.enabled);
  if (!enabled.length) {
    return `Selecciona al menos un ítem de ${label} con cantidad a solicitar.`;
  }
  const bad = enabled.find((item) => {
    const qty = Number(selectionMap[Number(item.id)]?.quantity ?? item.quantity ?? 0);
    return !Number.isFinite(qty) || qty <= 0;
  });
  if (bad) {
    return `Indica una cantidad mayor a 0 en los ${label} seleccionados.`;
  }
  return '';
};

export const selectedQuotationLines = (lineItems = [], selectionMap = {}) =>
  (lineItems || [])
    .map((item) => {
      const id = Number(item.id);
      const row = selectionMap[id];
      if (!row?.enabled) return null;
      const qty = Number(row.quantity ?? item.quantity ?? 0);
      if (!(qty > 0)) return null;
      return { ...item, requested_quantity: qty };
    })
    .filter(Boolean);
